<div id="centrale" class="row justify-content-md-center en-tête p-0 m-0">
    <h5 class="col-12 text-center pb-0 mb-0"> Emploi du temps </h5>
    <p> <input  (click)="onKey($event)" value="{{todate}}" name="date" class="col-9 mb-0 pb-0 mb-0" style="margin:1em" type="text" id="datepicker"></p>
  </div>

  <div class="row bodydashboard">
    <ul id="edt" class="list-group col-12 pr-0 overflow-auto mt-0 pt-0" style="max-height:22vh">
      <li class="list-group-item col-12  w-100 p-3 rounded-0" *ngFor="let item of tab, let i = index">
        <a id={{i}} href="#" data-toggle="modal" data-target="#EDTModal" (click)="setId($event)" style="color:black">{{tab[i].nom}} {{tab[i].prof}} {{tab[i].heuredeb}} </a> <a href="{{tab[i].zoom}}" target="_blank">lien</a>
      </li>
      
    </ul>
    <app-pop-up-info [info] = sendInfo(ind) [modalName] = "name"></app-pop-up-info>
  </div> 


  